import "../../style.scss";
import styles from "../../MapPopupStyles.js";
import { withStyles, withTheme } from "@material-ui/core/styles";
import { TableCell, TableHead, TableRow, Tooltip } from "@material-ui/core";
import { getIconByType } from "../../PopupUtil";
import { compose } from "recompose";

const Header = ({
  classes,
  theme,
  infoData,
  name,
  address,
  combinedIconsArray,
}) => {
  const themeName = theme.themeName;
  return (
    <TableHead className={classes.tableHead}>
      <TableRow className={classes.tableHeadHeight}>
        <TableCell colSpan={2} className={classes.tableHeaderCell}>
          <Tooltip
            classes={{ popper: "popper", tooltip: `tooltip-${themeName}` }}
            title={name}
          >
            <div className={classes.customerName}>{name}</div>
          </Tooltip>
          <Tooltip
            classes={{ popper: "popper", tooltip: `tooltip-${themeName}` }}
            title={infoData.routeName}
          >
            <span className={classes.routeInfo}>{infoData.routeName}</span>
          </Tooltip>
          <div>
            <Tooltip
              classes={{ popper: "popper", tooltip: `tooltip-${themeName}` }}
              title={address}
            >
              <div className={classes.address}>{address}</div>
            </Tooltip>
            <div className={classes.popupIconContainer}>
              {combinedIconsArray.slice(0, 5).map((element) => (
                <Tooltip
                  key={element.value}
                  classes={{ popper: "popper", tooltip: `tooltip-${themeName}` }}
                  title={element.tooltip}
                >
                  <div className={classes.popupIcon}>
                    {getIconByType({ iconData: element, backgroundColor: theme.headFontColor })}
                  </div>
                </Tooltip>
              ))}
            </div>
          </div>
        </TableCell>
      </TableRow>
    </TableHead>
  );
};

export default compose(withStyles(styles), withTheme())(Header);
